export default __webpack_public_path__ + "media/images/react_icons/heart_medical-24f80dcc65bd7d4d04ae1483ab5af9b0.svg";